import { Component, Input } from '@angular/core';

@Component({
  selector: 'log-list-view',
  templateUrl: './log-list-view.component.html',
  styleUrls: ['./log-list-view.component.scss'],
  standalone: false,
})
export class LogListViewComponent {
  public constructor() {}

  @Input() public logs: app.models.GetPagedAgentSyncLogModel[];
  @Input() public props: app.models.DynamicPropsDictionary;

  onSelectHandler(selectedItem: any) {
    navigator.clipboard
      .writeText(`Selected log exception:  ${selectedItem.timestamp} \n ${selectedItem.exception}`)
      .then()
      .catch(e => console.error(e));
  }
}
